import { Container, Graphics } from "pixi.js";
import { indoor } from "./common.js";

/**
 * FIMCP: taller. Es la sala más "de planta" del campus.
 *
 * El suelo lleva la franja de circulación, que es lo que distingue un taller de un
 * aula sin dibujar una sola máquina.
 */
export function fimcp(): Container {
  const scene = indoor({ wall: 0xd6d9db, floor: 0xb0b6ba, skirting: 0x8f979c });

  const hazard = new Graphics();
  hazard.rect(0, 470, 960, 14).fill(0xe8c33c);
  for (let i = 0; i < 40; i++) {
    hazard.rect(i * 26, 470, 12, 14).fill(0x2b2b2b);
  }
  scene.addChild(hazard);

  // Portón de carga al fondo, cerrado.
  const gate = new Graphics();
  gate.rect(60, 70, 220, 170).fill(0x9aa3a8).stroke({ width: 5, color: 0x6f787d });
  for (let i = 0; i < 6; i++) {
    gate
      .moveTo(60, 90 + i * 26)
      .lineTo(280, 90 + i * 26)
      .stroke({ width: 3, color: 0x7f888d });
  }
  scene.addChild(gate);

  // Tablero de herramientas: siluetas colgadas, no objetos del mapa.
  const board = new Graphics();
  board.rect(560, 80, 300, 150).fill(0xc75b39).stroke({ width: 5, color: 0x8c3f27 });
  for (let i = 0; i < 5; i++) {
    board.rect(586 + i * 56, 104, 10, 70).fill(0x3c4145);
    board.circle(591 + i * 56, 190, 14).fill(0x3c4145);
  }
  scene.addChild(board);

  return scene;
}
